import { MenuItemProps } from 'iebt-zing-storybook/dist/pages/Layout/Sidebar/MenuItem'
import { createMenu } from './createMenu'

class SideMenuBuilderFactory {
  build(): SideMenuBuilder {
    return new SideMenuBuilder()
  }
}

class SideMenuBuilder {
  build(currentLocation?: string, featureType?: string[], caixaRole?: 'solucionador' | 'avaliador'): MenuItemProps[] {
    return createMenu(currentLocation, featureType, caixaRole)
  }
}

const factory = new SideMenuBuilderFactory()
export const sideMenuBuilder = factory.build()

class SideMenuProfilesBuilderFactory {
  build(): SideMenuProfilesBuilder {
    return new SideMenuProfilesBuilder()
  }
}

class SideMenuProfilesBuilder {
  build(currentLocation?: string, featureType?: string[]): MenuItemProps[] {
    return createMenu(currentLocation, featureType)
  }
}

const factoryProfiles = new SideMenuProfilesBuilderFactory()
export const sideMenuProfilesBuilder = factoryProfiles.build()